import * as Colors from 'src/components/theme/colors'
import * as Shapes from 'src/components/theme/shapes'

export const useTypography = (typography: React.CSSProperties, important?: boolean) => {
  const importantCss = important ? ' !important' : ''

  return `
    font-family: ${typography.fontFamily}${importantCss};
    font-size: ${typography.fontSize}px${importantCss};
    line-height: ${typography.lineHeight}${importantCss};
    letter-spacing: ${typography.letterSpacing}px${importantCss};
    font-weight: ${typography.fontWeight}${importantCss};
  `
}

const HAS_WINDOW = typeof window !== 'undefined'

export const printStyle = (literals: TemplateStringsArray, ...placeholders: string[]): string => {
  const result = literals.reduce((res, literal, i) => `${res} ${literal} ${placeholders[i]}`, '')
  if (HAS_WINDOW && window.location.search.includes('print-debug')) {
    return result
  }
  return `
  @media print {
    ${result}
  }
  `
}

export const printPageStyle = (literals: TemplateStringsArray, ...placeholders: string[]): string => {
  const result = literals.reduce((res, literal, i) => `${res} ${literal} ${placeholders[i]}`, '')
  if (!HAS_WINDOW) {
    return ``
  }
  if (
    window.location.pathname === '/print' ||
    window.location.pathname === '/reports/presentation/print' ||
    window.location.pathname === '/report-widgets' ||
    window.location.pathname === '/match-analysis-print'
  ) {
    return result
  }
  return ``
}

export const printPseudoReportStyles = (): string => {
  if (!HAS_WINDOW || window.location.pathname !== '/match-analysis-print') {
    return ``
  }
  return `
    html {
      background-color: ${Colors.bgDark};
    }
    @page {
      margin: 0;
    }
  `
}

export const PRINT_HIDE = printStyle`display: none;`

export const themeSpacing = (index: number) => {
  return Shapes.spacing[index] || 0
}
